module.exports = __webpack_public_path__ + "static/media/The Community HUB.47b4e4bc.png";